package com.rosario.juridico.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

// Colores de acento y branding
val Gold400      = Color(0xFFE0A800)
val PrimaryDeepBlue = Color(0xFF0D2B4A)
val EmeraldGreen = Color(0xFF10B981)

private val LightColors = lightColorScheme(
    primary            = PrimaryDeepBlue,
    onPrimary          = Color.White,
    primaryContainer   = Color(0xFFE2E8F0),
    onPrimaryContainer = PrimaryDeepBlue,
    secondary          = Gold400,
    onSecondary        = Color.White,
    tertiary           = EmeraldGreen,
    onTertiary         = Color.White,
    background         = Color(0xFFF4F6F8),
    onBackground       = Color(0xFF0F172A),
    surface            = Color.White,
    onSurface          = Color(0xFF0F172A),
    surfaceVariant     = Color(0xFFF1F5F9),
    onSurfaceVariant   = Color(0xFF64748B),
    outline            = Color(0xFFE2E8F0),
    outlineVariant     = Color(0xFFCBD5E1),
    error              = Color(0xFFEF4444),
    onError            = Color.White,
)

private val DarkColors = darkColorScheme(
    // Estética "Midnight Petroleum" (Azules profundos y Naranja)
    primary            = Color(0xFF3B82F6), 
    onPrimary          = Color.White,
    primaryContainer   = Color(0xFF1D4ED8),
    onPrimaryContainer = Color(0xFFDBEAFE),
    
    // Fondo azul medianoche (casi negro) como en la imagen
    background         = Color(0xFF040D1A), 
    onBackground       = Color(0xFFF8FAFC),
    
    // Superficie azul petróleo para tarjetas
    surface            = Color(0xFF162231), 
    onSurface          = Color(0xFFF1F5F9),
    
    // Inputs y variantes en azul grisáceo
    surfaceVariant     = Color(0xFF1E293B),
    onSurfaceVariant   = Color(0xFFCBD5E1),
    
    // Acento naranja (FAB de la imagen)
    secondary          = Color(0xFFE67E22), 
    onSecondary        = Color.White,
    secondaryContainer = Color(0xFF334155),
    onSecondaryContainer = Color(0xFFE2E8F0),
    
    outline            = Color(0xFF334155),
    error              = Color(0xFFF87171),
    onError            = Color(0xFF450A0A)
)

@Composable
fun JuridicoTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit
) {
    val colorScheme = if (darkTheme) DarkColors else LightColors

    MaterialTheme(
        colorScheme = colorScheme,
        content     = content
    )
}
